module.exports = __webpack_public_path__ + "img/staticIcon.5ef1a612.png";